import { API, Auth } from 'aws-amplify';
import * as constants from "../config/constants";
import * as types from "../actions/types";
import * as actions from "../actions";
import { getDeltaId } from "./auth";

export async function fetchStudent(dispatch) {
  try {
    dispatch({type: types.FETCH_USER_REQUEST});
    const deltaId = await getDeltaId();
    if (!deltaId)
      throw new Error("Failed to get Delta Id for Authenticated User");
    const user = await API.get(
      "students",
      `students/${encodeURIComponent(await getDeltaId())}`,
      {}
      );
    dispatch({type: types.FETCH_USER_SUCCESS});
    return { status: true, user };
  } catch (e) {
    dispatch({type: types.FETCH_USER_FAILURE});
    if(typeof e.response === 'object' && e.response.status === 404) {
      return { status: false, reason: constants.REASON_NOT_FOUND};
    }
    return { status: false, reason: e.message };
  }
}

export async function createStudent(dispatch) {
  dispatch({type: types.CREATE_USER_REQUEST});
  let user = await Auth.currentAuthenticatedUser();
  const { deltaId } = user;
  const body = {
    deltaId
  };
  try {
    const result = await API.post("students", "students", { body, response: true });
    dispatch({type: types.CREATE_USER_SUCCESS});
    if(result.status === 200 || result.status === 202) {
      if(result.data.complete)
        dispatch(actions.unsetNewUser());
      return {status: true, user: result.data};
    }
    return {status: false, reason: 'UNKNOWN'};
  } catch (e) {
    dispatch({type: types.CREATE_USER_FAILURE});
    return {status: false, reason: e.response};
  }
}

export async function fetchPeriods(dispatch) {
  try {
    dispatch(actions.requestPeriods());
    const periods = await API.get("periods", "periods", {});
    dispatch(actions.receivePeriods(periods));
  } catch (e) {
    dispatch(actions.addAlert('danger', e.message));
    dispatch(actions.requestPeriodsFailure(e.message));
  }
}

export async function fetchStudentApplication(studentId, applicationId) {
  const applicationEndpoint = `students/${encodeURIComponent(studentId)}/applications/${encodeURIComponent(applicationId)}`;
  try {
    const application = await API.get("students", applicationEndpoint, {});
    return { status: true, application };
  } catch (e) {
    return { status: false, reason: e.message };
  }
}

export async function createStudentApplication(studentId, application) {
  const applicationsEndpoint = `students/${encodeURIComponent(studentId)}/applications`;
  try {
    const result = await API.post('students', applicationsEndpoint, { body: application });
    return { status: true, application: result.data };
  } catch (e) {
    return { status: false, reason: e.message };
  }
}

export async function updateStudentApplication(studentId, applicationId, updates) {
  const applicationEndpoint = `students/${encodeURIComponent(studentId)}/applications/${encodeURIComponent(applicationId)}`;
  try {
    const application = await API.put("students", applicationEndpoint, { body: updates });
    return { status: true, application };
  } catch (e) {
    return { status: false, reason: e.message };
  }
}

export async function updateStudentApplicationStatus(studentId, applicationId, status) {
  const applicationEndpoint = `students/${encodeURIComponent(studentId)}/applications/${encodeURIComponent(applicationId)}/status`;
  try {
    const application = await API.put("students", applicationEndpoint, { body: { status } });
    return { status: true, application };
  } catch (e) {
    return { status: false, reason: e.message };
  }
}

export async function deleteStudentApplication(studentId, applicationId) {
  const applicationEndpoint = `students/${encodeURIComponent(studentId)}/applications/${encodeURIComponent(applicationId)}`;
  try {
    const { status, user } = await API.del("students", applicationEndpoint);
    return { status, user };
  } catch (e) {
    return { status: false, reason: e.message };
  }
}